import { Suspense, type PropsWithChildren } from 'react'

import { BuscaClienteSkeleton } from '@/components/busca-cliente-skeleton'
import { PageLayoutSkeleton } from '@/layouts/page'

export const BuscarClientePageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <BuscaClienteSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
